import { render, staticRenderFns } from "./FollowInterestInfo.vue?vue&type=template&id=624c82fc&"
import script from "./FollowInterestInfo.vue?vue&type=script&lang=js&"
export * from "./FollowInterestInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports